<div class="action-plan {{moduleKey}}">

  <div id="action-plan-complete" {{#if complete}}class="active"{{/if}}>
    <div class="heading"></div>
    <h4>{{t 'actionPlan.subheader'}}</h4>
    <span class="name">{{t 'actionPlan.completeTitle'}}</span>
    <div class="steps-description">
      <p>{{ t 'actionPlan.stepDone'}}</p>
    </div>

    <div id="summary">
      <span class="title"></span>
      <p class="body">{{t 'actionPlan.summaryText' }}</p>
      <div id="email-summary">
        <label for="send-email">
          <input type="checkbox" name="send-email" id="send-email" role="checkbox" aria-checked="true" checked>
          {{t 'actionPlan.sendEmail'}}
        </label>
        <input type="email" id="email" value="{{email}}" placeholder="{{{pt 'actionPlan.emailPlaceholder'}}}">
        <div id="email-error" role="alert" aria-live="polite">{{t 'actionPlan.emailErrorMessage'}}</div>
      </div>
      <a role="button" href="#menu/action-plan-responses?key={{moduleKey}}" class="btn" id="view-plan-btn">{{t 'actionPlan.viewMyPlan'}}</a>
    </div>
  </div>

</div>
